import React, { ReactElement } from "react";
import Layout from "Layout";
import UserForm from "./UserForm";
import styles from "./styles.module.scss";

function ManageUser(): ReactElement {
  return (
    <Layout>
      <div className={styles.ManageUsersPage}>
        <h1>Manage Users</h1>
        <div className={styles.barContainer}>
          <div className={styles.bar} />
        </div>
        <div className={styles.manageClientForm}>
          <UserForm />
        </div>
      </div>
    </Layout>
  );
};

export default ManageUser;
